var slickInit;

(function ($) {

	const selectors = {
		'prevArrow': '[data-prev-arrow]',
		'nextArrow': '[data-next-arrow]',
	};

	slickInit = function () {

		new SlickSlider('.c-home-banner__slider', {
			fade: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 1500,
			arrows: false,
			pauseOnHover: false,
			dots: true,
			loop: true,
			events: {
				init: function (e, slick) {
					setTimeout(_ => {
						slick.$slides.eq(0).addClass('is-in-view');
					}, 10);

				},
				beforeChange: function (e, slick, currentSlide, nextSlide) {
					slick.$slides.eq(nextSlide).addClass('is-in-view');
					slick.$dots.children().removeClass('before-current');
					if (nextSlide > 0) slick.$dots.children().eq(currentSlide).addClass('before-current');
				},
				afterChange: function (e, slick, currentSlide) {
					slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
				}
			}
		});

		new SlickSlider('.c-home-intro__photos', {
			fade: true,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			arrows: true,
			pauseOnHover: false,
			dots: true,
			loop: true,
			prevArrow: $(selectors.prevArrow, $('.c-home-intro__photos').closest('section')),
			nextArrow: $(selectors.nextArrow, $('.c-home-intro__photos').closest('section')),
		});

		new SlickSlider('.c-news-slider', {
			arrows: false,
			dots: true,
			mobileFirst: true,
			loop: true,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 900,
					settings: 'unslick'
				}
			]
		})

	}

	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {

			this.onResize = this.onResize.bind(this);

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

		}

		init() {
			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}

})(jQuery);


export default slickInit;